import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiAlert } from "@ryde/controls";
import { useReportsContext } from "@ryde/redux";

export const GridRowLimitExceededPanel: FC = () => {
  const { t } = useTranslation();
  const { reportDto } = useReportsContext();

  return (
    <MuiAlert
      sx={{ marginTop: "20px", marginInlineEnd: "20px" }}
      severity="warning"
    >
      {t("report.GRID_ROW_LIMIT_EXCEEDED", {
        limit: reportDto?.reportTemplate?.gridRowLimit ?? "",
      })}
    </MuiAlert>
  );
};
